var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7092 7.60693L12.9209 7.61235V7.61254L12.7092 7.60693Z",
    fill: "#2C625F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7943 11.0281C12.7144 10.1068 13.2327 9.0111 13.3365 7.76904L14.6173 7.91229L14.6345 7.91411L14.6519 7.91478C14.7519 7.91796 14.8834 7.92331 15.0134 7.93925C15.0414 7.94254 15.0691 7.94658 15.0969 7.95067C14.9336 9.5859 14.211 11.1155 13.0464 12.2801C11.6999 13.6269 9.90954 14.3683 8.00529 14.3683C6.20978 14.3683 4.51579 13.7084 3.19949 12.5041L4.45346 11.2501C5.43258 12.1192 6.6802 12.5953 8.00178 12.5953C9.43669 12.5953 10.7835 12.0387 11.7943 11.0281Z",
    fill: "#2C625F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05995 0.165039C9.96457 0.165039 11.7544 0.906536 13.1009 2.25295C13.2593 2.4112 13.4087 2.57593 13.5502 2.74643L12.2881 4.00859C12.1515 3.83291 12.0074 3.66331 11.8488 3.50495C10.8382 2.49466 9.49389 1.93804 8.06343 1.93785C6.62842 1.93804 5.28157 2.49466 4.27068 3.50495C3.29468 4.48132 2.74281 5.77193 2.70756 7.1522C2.12116 7.05593 1.53321 6.96168 0.945377 6.86743C1.04856 5.12318 1.77956 3.49257 3.01885 2.25295C4.36536 0.906536 6.15533 0.165039 8.05922 0.165039H8.05995Z",
    fill: "#2C625F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8509 1.44604L15.5881 6.43396L10.6132 5.6835L12.2881 4.00876L13.5501 2.74658L14.8509 1.44604Z",
    fill: "#1E4140"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45343 11.2504L3.19944 12.5043L1.9154 13.7884L1.16505 8.81348L6.1532 9.5507L4.45343 11.2504Z",
    fill: "#1E4140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.b7a0bf2f19f14213303218999dafebb3.svg";
export { ForwardRef as ReactComponent };